export { IntakeType } from './generated/IntakeType.js';